
import * as axios from '@/axios/index'

const state = {
  skillInfo: {
    screenshotImageUrlList: [],
    screenshotImageUrlHideList: [],
  },
  gameInfo: {},
  quickSkills: []
  // reddotInfo: {},
};

const mutations = {
  SET_SKILL_INFO: (state, payload) => {
    state.skillInfo = payload;
  },
  SET_GAME_INFO: (state, payload) => {
    state.gameInfo = payload;
  },
  SET_GAME_QUICK: (state, payload) => {
    state.quickSkills = payload;
  },
  // SET_REDDOT_INFO: (state, payload) => {
  //   state.reddotInfo = payload;
  // },
};

const actions = {
  getQuickGame({ commit }) {
    return axios
      .get('/game/list/quick/match')
      .then(({ data }) => {
        if (data) {
          commit('SET_GAME_QUICK', data)
        }
      })
  },
  getSkillInfo: (() => {
    let promiseObj
    function init () {
      promiseObj = {}
      promiseObj.promise = new Promise((resolve) => {
        promiseObj.resolve = resolve
      })
    }
    return ({ commit, state }, params) => {
      if (!params || (state.skillInfo && state.skillInfo.id === +(params.skillId))) {
        return Promise.resolve(state.skillInfo)
      } else {
        init()
        axios.get('/player/skill/detail/info', {
          id: +(params.skillId),
          showHide: true,
        }).then(({ data }) => {
          if (data.screenshotImageUrlList) {
            data.screenshotImageUrlList = JSON.parse(data.screenshotImageUrlList)
          } else {
            data.screenshotImageUrlList = []
          }
          if (data.screenshotImageUrlHideList) {
            data.screenshotImageUrlHideList = JSON.parse(data.screenshotImageUrlHideList)
          } else {
            data.screenshotImageUrlHideList = []
          }
          commit('SET_SKILL_INFO', data)
          promiseObj.resolve(data)
        })
        return promiseObj.promise
      }
    }
  })(),
  getGameInfo: (() => {
    let promiseObj
    function init () {
      promiseObj = {}
      promiseObj.promise = new Promise((resolve) => {
        promiseObj.resolve = resolve
      })
    }
    return ({ commit, state }, params) => {
      if (!params || (state.gameInfo && state.gameInfo.id === +(params.gameId))) {
        return Promise.resolve(state.gameInfo)
      } else {
        init()
        axios.get('/player/skill/certification/gameinfo', {
          gameId: +(params.gameId)
        })
          .then(({ data }) => {
            commit('SET_GAME_INFO', data)
            promiseObj.resolve(data)
          })
        return promiseObj.promise
      }
    }
  })(),
  setSkillInfo: ({ commit, state }, payload) => {
    const skillInfo = { ...state.skillInfo }
    for (var attr in payload) {
      skillInfo[attr] = payload[attr]
    }
    if (skillInfo.screenshotImageUrlList && (typeof skillInfo.screenshotImageUrlList === 'string')) {
      skillInfo.screenshotImageUrlList = JSON.parse(skillInfo.screenshotImageUrlList)
    } else if (skillInfo.screenshotImageUrlList === null) {
      skillInfo.screenshotImageUrlList = []
    }
    if (skillInfo.screenshotImageUrlHideList && (typeof skillInfo.screenshotImageUrlHideList === 'string')) {
      skillInfo.screenshotImageUrlHideList = JSON.parse(skillInfo.screenshotImageUrlHideList)
    } else if (skillInfo.screenshotImageUrlHideList === null) {
      skillInfo.screenshotImageUrlHideList = []
    }
    commit('SET_SKILL_INFO', skillInfo)
  },
  // getReddot: ({ commit }) => {
  //   return axios.get('/reddot/info').then(({ data: { firstOrderDiscount } }) => {
  //     for (var id in firstOrderDiscount) {
  //       firstOrderDiscount[id] = !!firstOrderDiscount[id]
  //     }
  //     commit('SET_REDDOT_INFO', firstOrderDiscount || {})
  //   })
  // },
  // cleanReddot: ({ commit, state }, playerSkillId) => {
  //   delete state.reddotInfo[playerSkillId]
  //   commit('SET_REDDOT_INFO', state.reddotInfo)
  //   return axios.post('/reddot/clean', {
  //     field: 'firstOrderDiscount',
  //     playerSkillId,
  //   })
  // }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
